import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog as MUIDialog,
  DialogContent,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";

import { useAlert, useAxios } from "../../../hooks";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";
import AudienceSizeForm from "../superadmin campaign details component/AudienceSizeForm";

export default function ShowAudienceSizeDialog({
  formikProps,
  showAudSize,
  setShowAudSize,
  audienceSize,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShowAudSize(false);
  };

  const handleCampaignLive = () => {
    setLoading(true);
    axios({
      url: "/campaign/makeCampaignLive",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: parseInt(formikProps.values.campaignID),
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          IsManualCampaignLive: response.data.isManualCampaignLive,
          status: response.data?.status,
          campaignStatus: response.data?.campaignStatus,
          newCampaignStatus: response.data?.campaign_status || "LIVE_REQUESTED",
        }));
        dispatch(
          alert({ type: "success", message: response.message.displayMessage })
        );
        setShowAudSize(false);
      }
      setLoading(false);
    });
  };

  return (
    <MUIDialog open={showAudSize} onClose={handleClose}>
      <Grid container spacing={4} padding={"8px 24px"}>
        <Grid size={6} alignSelf={"center"}>
          <ActiveTextEighteen color={colors.sprintexBlue}>
            Audience Size
          </ActiveTextEighteen>
        </Grid>

        <Grid size={6} alignSelf={"center"} textAlign={"end"}>
          <IconButton>
            <HighlightOff onClick={() => handleClose()} />
          </IconButton>
        </Grid>
      </Grid>

      <Divider />

      <DialogContent style={{ padding: "24px" }}>
        <Grid container spacing={4}>
          <AudienceSizeForm
            campaign={formikProps?.values}
            formikProps={audienceSize}
            component="consumer"
          />
        </Grid>

        {formikProps?.values.status !== "ACTIVE" &&
          !formikProps?.values.isCampaignLive && (
            <Grid container justifyContent={"end"} mt={2}>
              <PrimaryLoadingButton
                variant="contained"
                loading={loading}
                onClick={handleCampaignLive}
              >
                Campaign Go Live
              </PrimaryLoadingButton>
            </Grid>
          )}
      </DialogContent>
    </MUIDialog>
  );
}
